import Lottie from "lottie-react";
import Loading from "../assets/loading.json";

export default function LoadingLottie() {
  return (
    <div style={{ width: 400, margin: "auto" }}>
      <Lottie animationData={Loading} loop={true} />
    </div>
  );
}
